import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import { useForm } from "react-hook-form";
import { ListarEmpreendimentosController } from "../../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { MoneyReaisFieldMask } from "../../../../../../Validations/InputMasks";
import { IFiltroListarContatos } from "../../../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { ListarJornadaEtapaController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/JornadaEtapa/JornadaEtapaController";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";

interface IModalFiltroContatosProps {
    filter: any;
    filtroGestaoStorage: any;
    setIdEmpreendimento: Dispatch<SetStateAction<number[]>>;
    idEmpreendimento: Array<number>;
    filtroInicial: IFiltroListarContatos;
    updateList: (filter: IFiltroListarContatos, page: number) => void;
}

export function useModalFiltroContatos(props: IModalFiltroContatosProps) {
    const FormMethods = useForm<IFiltroListarContatos>();
    const { reset, setValue, errors } = FormMethods;
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    function maskReal(inputName: keyof IFiltroListarContatos) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            setValue(inputName, mask);
        };
    }
    const { execute: listarJornadaEtapa } = useAsyncCallback(
        () => ListarJornadaEtapaController(true),
        []
    );
    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );
    const idEmpreendimentoRef = useRef<any>();
    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
    };

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const handleFilterContact = (formData: IFiltroListarContatos) => {
        const filterFormData: IFiltroListarContatos = {
            ...formData,
            QUANTIDADE: 10,
            PAGINA: props.filtroInicial.PAGINA,
            ID_AUDIENCIA: props.filtroInicial.ID_AUDIENCIA,
            ID_CONTA: 0,
            NR_UNIDADES_FINAL: formData.NR_UNIDADES_FINAL
                ? formData.NR_UNIDADES_FINAL
                : 0,
            NR_UNIDADES_INICIAL: formData.NR_UNIDADES_INICIAL
                ? formData.NR_UNIDADES_INICIAL
                : 0,
            FL_VINCULADO: props.filtroInicial.FL_VINCULADO,
        };
        props.filter.current = filterFormData;
        props.filtroGestaoStorage.set(filterFormData);
        props.updateList(filterFormData, 1);
    };

    return {
        FormMethods,
        handleFilterContact,
        maskReal,
        setValue,
        errors,
        idEmpreendimentoRef,
        options,
        customStyles,
        listarJornadaEtapa,
        limparFiltros,
        reset,
    };
}
